import cn from 'classnames';
import { TPlansDetails } from 'src/types/plans.types';
import SelectPlanButton from '../SelectPlanButton';
import styles from './pricing.module.scss';

type ActionsRowProps = {
  smartHomePlan: TPlansDetails['smartHome'];
  secondaryPlan: TPlansDetails['secondary'];
  billingCycle: string;
  planButtonLabel: string;
  columnClass: string;
  addToCart: BaseAnyFunction;
};
const ActionsRow = ({ smartHomePlan, secondaryPlan, billingCycle, planButtonLabel, columnClass = '', addToCart }: ActionsRowProps) => {
  const { id: smartHomePlanId } = smartHomePlan[billingCycle] || {};
  const { id: secondaryPlanId } = secondaryPlan[billingCycle] || {};

  return (
    <div className={styles.row}>
      <div className={cn(styles.selectPlanCol, columnClass)} />
      <div className={cn(styles.smartHomeCol, columnClass)}>
        <SelectPlanButton label={planButtonLabel} addToCart={() => addToCart({ planId: smartHomePlanId })} />
      </div>
      <div className={cn(styles.secondaryCol, columnClass)}>
        <SelectPlanButton label={planButtonLabel} addToCart={() => addToCart({ planId: secondaryPlanId })} />
      </div>
    </div>
  );
};

export default ActionsRow;
